import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, FormSection, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../text/messages';
import { normalizeEIN } from './../../../../../utilities/string';
import { formSettings } from './settings';
import { TextField } from './../../../../../components/fields';
import { required } from './../../../../../utilities/validation';
import Table from '../../../../../components/table';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { getAddresses, saveAddress } from '../../../../../reducers/addresses';
import { updateUserDetails } from '../../../../../reducers/identity';
import AddressComponent from '../../../../../components/address';

class CompanyInformationStep extends React.Component {
    constructor(props) {
        super(props);

        this.renderPrimaryContactData = this.renderPrimaryContactData.bind(this);
        this.renderAddressFields = this.renderAddressFields.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        let { role, addresses, getAddresses } = this.props;
        if (!addresses) {
            getAddresses(role);
        }
    }

    submit(values, action) {
        const { role, client, saveAddress, updateUserDetails } = this.props;
        const { name, fein, web_site, address } = values;

        let saveStepData = data => {
            updateUserDetails(role, { ...client, ...data, address: undefined }, action);
        };

        address.name = address.name || 'Company';
        saveAddress({ ...address, ref_id: role.id, ref_type: role.type, kind: 'p' }, result => {
            let data = { name, fein, web_site, address: { ...address, id: result.id } };
            saveStepData(data);
        });
    }

    renderPrimaryContactData() {
        const { profile } = this.props;
        const { first_name, last_name, email, phone, phone_ext } = profile;
        let phoneNumber = phone ? `${phone_ext ? `${phone_ext} ` : ''} ${phone}` : <FormattedMessage {...messages.notProvided} />;

        return (
            <Table
                rowStyle="onboarding-table-row"
                columns={[
                    { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                    { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
                ]}
                data={[
                    { label: <FormattedMessage {...messages.firstName} />, value: first_name },
                    { label: <FormattedMessage {...messages.lastName} />, value: last_name },
                    { label: <FormattedMessage {...messages.email} />, value: email },
                    { label: <FormattedMessage {...messages.phoneNumber} />, value: phoneNumber }
                ]}
            />
        );
    }

    renderAddressFields() {
        const { form } = this.props;

        return (
            <div className="row section">
                <div className="col-xs-12 col-sm-8">
                    <FormSection name={'address'}>
                        <div className="row">
                            <AddressComponent form={form} section={'address'} hideName={true} />
                        </div>
                    </FormSection>
                </div>
            </div>
        );
    }

    render() {
        const { handleSubmit, onSubmit, submitting, addresses } = this.props;
        if (!addresses) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12 col-sm-8">
                        <Field name="name" validate={required} component={TextField} placeholder={messages.companyName} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <Field
                            name="fein"
                            id="onboarding-comp-tax-id"
                            validate={required}
                            normalize={normalizeEIN}
                            component={TextField}
                            placeholder={messages.companyTaxId}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <Field name="web_site" id="onboarding-comp-website" validate={required} component={TextField} placeholder={messages.companyURL} />
                    </div>
                </div>

                {this.renderAddressFields()}

                <WizardButtons id={{ id: 'onboarding-comp-continue' }} disabled={submitting} />
            </form>
        );
    }
}

CompanyInformationStep = reduxForm(formSettings)(CompanyInformationStep);
const mapStateToProps = state => {
    let client = state.identity.details;
    let addresses = state.addresses.list;
    let initialValues = {
        name: client.name,
        fein: client.fein,
        web_site: client.web_site,
        address: addresses && addresses.length > 0 ? addresses[0] : { country: 'US' }
    };
    return {
        role: state.identity.role,
        profile: state.identity.profile,
        client,
        addresses,
        initialValues
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAddresses: getAddresses,
            saveAddress: saveAddress,
            updateUserDetails: updateUserDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInformationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/client/steps/companyInformation.jsx